import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ru from '../../../../messages/ru.json'
import uz from '../../../../messages/uz.json'
import uzCyrl from '../../../../messages/uz-cyrl.json'

export const i18nCookieName = 'i18nextLng'

const supportedLngs = ['ru', 'uz', 'uz-Cyrl']
const storedLng = localStorage.getItem('appLng')
const initialLng = supportedLngs.includes(storedLng ?? '') ? storedLng! : 'ru'

i18n.use(initReactI18next).init({
  resources: {
    ru: {
      translation: ru,
    },
    uz: {
      translation: uz,
    },
    'uz-Cyrl': {
      translation: uzCyrl,
    },
  },
  lng: initialLng,
  fallbackLng: 'ru',
  supportedLngs,
  load: 'currentOnly',
  interpolation: {
    escapeValue: false,
  },
})

export const setSSRLanguage = async () => {}

export default i18n
